module.exports = __webpack_public_path__ + "static/media/paypal.7a5041e3.svg";